// extracted by mini-css-extract-plugin
export default {"footerTable":"styles_footerTable__wDCRz"};